"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
//
const CustomIcons_1 = require("./CustomIcons");
// ----------------------------------------------------------------------
function Radio(theme) {
    return {
        MuiRadio: {
            defaultProps: {
                icon: (0, jsx_runtime_1.jsx)(CustomIcons_1.RadioIcon, {}),
                checkedIcon: (0, jsx_runtime_1.jsx)(CustomIcons_1.RadioCheckedIcon, {}),
            },
            styleOverrides: {
                root: ({ ownerState }) => ({
                    padding: theme.spacing(1),
                    ...(ownerState.size === 'small' && {
                        '& svg': { width: 20, height: 20 },
                    }),
                    ...(ownerState.size === 'medium' && {
                        '& svg': { width: 24, height: 24 },
                    }),
                }),
            },
        },
    };
}
exports.default = Radio;
